import Typography from '@mui/material/Typography';
import { FooterAction, Row } from '../../interfaces';
import {
  GetWaiversData,
  WaiverRequestWithCustomerAndEvents,
} from '../../types/waivers';
import WaiverStatusBadge from '../../components/waivers/WaiverStatusBadge';
import {
  getWaiverLastUpdateText,
  getWaiverNextUpdateText,
} from '../../helpers/waivers';
import DropdownMenu from '../../components/global/DropdownMenu';
import { HeaderCells } from '../../types/ui';
import CustomerNameAge from '../../components/appointments/CustomerNameAge';

export const headerCells = [
  { id: 'customer', label: 'Client' },
  { id: 'status', label: 'Waiver status' },
  { id: 'provider', label: 'Service provider' },
  { id: 'Last update', label: 'Last update' },
  { id: 'Next update', label: 'Next update' },
  { id: 'empty', label: '' },
] as const satisfies HeaderCells;

// Function to create a table row from a single waiver request
function createRow({
  waiverRequest,
  createMoreActions,
  waivers,
}: {
  waiverRequest: WaiverRequestWithCustomerAndEvents;
  createMoreActions: (
    waiver: WaiverRequestWithCustomerAndEvents,
  ) => FooterAction[];
  waivers: GetWaiversData[];
}) {
  const providerName = waiverRequest.appointment.employees?.displayName;
  const moreActions = createMoreActions(waiverRequest);

  const row = {
    rowId: waiverRequest.id,
    cells: [
      <CustomerNameAge waiverRequest={waiverRequest} minorForAppointment />,
      <WaiverStatusBadge
        appointment={waiverRequest.appointment}
        waiverRequest={waiverRequest}
        waivers={waivers}
      />,
      <Typography variant="body1">{providerName}</Typography>,
      <Typography variant="body1">
        {getWaiverLastUpdateText(waiverRequest)}
      </Typography>,
      <Typography variant="body1">
        {getWaiverNextUpdateText({
          appointment: waiverRequest.appointment,
          waiverRequest,
          waivers,
        })}
      </Typography>,
      <DropdownMenu options={moreActions} />,
    ],
  };

  return row;
}

// Function to create all rows for an array of waiver requests
export function createRows({
  items,
  createMoreActions,
  waivers,
}: {
  items: WaiverRequestWithCustomerAndEvents[] | undefined;
  createMoreActions: (
    waiver: WaiverRequestWithCustomerAndEvents,
  ) => FooterAction[];
  waivers: GetWaiversData[];
}) {
  if (!items) {
    return [];
  }

  const rows: Row[] = [];
  items.forEach(item => {
    rows.push(createRow({ waiverRequest: item, createMoreActions, waivers }));
  });
  return rows;
}
